export default "__VITE_ASSET__DpbP0a2F__"